export const BREAKPOINTS = {
    SM: '(min-width: 640px)',
    MD: '(min-width: 768px)',
    LG: '(min-width: 1024px)',
    XL: '(min-width: 1280px)',
};
